import React from 'react';
import styles from './EmoticonPicker.module.css';

// 버튼 아이콘 (로컬 import)
import emoticonBtnIcon from '../../assets/pic/122423278.png';

// 이모티콘은 public 폴더에서 절대 경로로 접근 (서버 전송용)
const EMOTICONS = [
    { id: 1, src: '/emoticon/1.png' },
    { id: 2, src: '/emoticon/2.png' },
    { id: 3, src: '/emoticon/3.png' },
    { id: 4, src: '/emoticon/4.png' },
    { id: 5, src: '/emoticon/5.png' },
    { id: 6, src: '/emoticon/6.png' },
    { id: 7, src: '/emoticon/7.png' },
    { id: 8, src: '/emoticon/8.png' },
    { id: 9, src: '/emoticon/9.png' },
    { id: 10, src: '/emoticon/10.png' },
];

/**
 * 이모티콘 버튼 컴포넌트 (버튼만)
 */
export const EmoticonButton = ({ onClick }) => (
    <div className={styles.container}>
        <button
            className={styles.toggleBtn}
            onClick={onClick}
            aria-label="이모티콘"
            type="button"
        >
            <img src={emoticonBtnIcon} alt="이모티콘" className={styles.btnIcon} />
        </button>
    </div>
);

/**
 * 이모티콘 패널 컴포넌트 (카카오톡 스타일 바텀시트)
 */
export const EmoticonPanel = ({ isOpen, onClose, onSelect }) => {
    if (!isOpen) return null;

    const handleSelect = (emoticon) => {
        onSelect?.(emoticon);
    };

    return (
        <>
            {/* 배경 클릭 시 닫기 */}
            <div className={styles.overlay} onClick={onClose} />

            <div className={styles.panel}>
                <div className={styles.panelHeader}>
                    <span className={styles.panelTitle}>이모티콘</span>
                    <button
                        className={styles.closeBtn}
                        onClick={onClose}
                        type="button"
                    >
                        ✕
                    </button>
                </div>
                <div className={styles.grid}>
                    {EMOTICONS.map((emoticon) => (
                        <button
                            key={emoticon.id}
                            className={styles.emoticonBtn}
                            onClick={() => handleSelect(emoticon)}
                            type="button"
                        >
                            <img
                                src={emoticon.src}
                                alt={`이모티콘 ${emoticon.id}`}
                                className={styles.emoticonImg}
                            />
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
};

/**
 * 이모티콘 선택 패널 컴포넌트 (통합 - 기존 호환)
 */
const EmoticonPicker = ({ isOpen, onToggle, onSelect }) => {
    return (
        <>
            <EmoticonButton onClick={onToggle} />
            <EmoticonPanel
                isOpen={isOpen}
                onClose={onToggle}
                onSelect={onSelect}
            />
        </>
    );
};

export default EmoticonPicker;
